import { Menu } from "../model/menu.model"
import { FittingkerMenuItems } from "./fittingker.menu";

  export var CRMMenuItems: Menu[] = [
    {
      headTitle1: "CRM",
    }
  ];